import { useMemo } from 'react';
import { Radar } from 'react-chartjs-2';
import '../../lib/chartjs';

interface RadarChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string;
      borderColor: string;
      borderWidth: number;
    }[];
  };
}

export const RadarChartComponent: React.FC<RadarChartProps> = ({ data }) => {
  const options = useMemo(() => ({
    layout: {
      padding: 0
    },
    scales: {
      r: {
        angleLines: {
          color: 'rgba(148, 163, 184, 0.3)', // slate-400 mais sutil
        },
        grid: {
          color: 'rgba(148, 163, 184, 0.2)', // slate-400 mais sutil
        },
        pointLabels: {
          font: {
            size: 10,
            weight: '500' as const
          },
          color: '#374151',
          callback: function(label: string) {
            if (label.length > 8) {
              // Quebra a label em duas linhas se for muito longa
              const words = label.split(' ');
              if (words.length > 1) {
                const mid = Math.ceil(words.length / 2);
                return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
              } else {
                // Se for uma palavra só, corta na metade
                const mid = Math.ceil(label.length / 2);
                return [label.slice(0, mid), label.slice(mid)];
              }
            }
            return label;
          }
        },
        ticks: {
          backdropColor: 'transparent',
          backdropPadding: { 
            x: 10, 
            y: 4 
          },
          color: '#9CA3AF',
          stepSize: 25,
          font: {
            size: 10,
          },
          showLabelBackdrop: false,
          display: false
        },
        suggestedMin: 0,
        suggestedMax: 100,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
        align: 'center' as const,
        labels: {
          color: '#64748b',
          font: {
            size: 10,
            weight: '500' as const
          },
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 20,
          boxWidth: 8,
          boxHeight: 8
        },
      },
      tooltip: {
        backgroundColor: 'rgba(42, 35, 31, 0.95)', // neutral-900 com transparência
        titleColor: '#F5F1EC', // neutral-50
        bodyColor: '#F5F1EC', // neutral-50
        borderColor: 'rgba(138, 115, 96, 0.3)', // neutral-500
        borderWidth: 1,
        cornerRadius: 8,
        callbacks: {
          label: function(context: any) {
            return `${context.dataset.label}: ${context.formattedValue}%`;
          }
        }
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    elements: {
      point: {
        radius: 3,
        hoverRadius: 5,
        borderWidth: 0,
      },
      line: {
        borderWidth: 2,
        tension: 0.3,
      },
    },
  }), []);

  return <Radar data={data} options={options} />;
}; 